import { render, staticRenderFns } from "./UserMaps.vue?vue&type=template&id=06c263df&"
import script from "./UserMaps.vue?vue&type=script&lang=js&"
export * from "./UserMaps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports